import {api2Endpoint} from 'app/config/apiConfig'
import {postData} from 'app/hooks/api/usePostData'
import {queryDefaults} from 'app/react-query'
import {useQuery} from 'react-query'
import errorNotify from '../api/utils/errorNotify'

export function useGetEntityResultsByConceptV2<T>(
  args?: {
    entity: string
    page?: number
    perPage?: number
    concept_ids?: any
    filters?: Record<string, any>
    filter_keywords?: string[]
    algorithm?: string
    queryFilterId?: string
    order?: string[]
  },
  errMsg = `Could not retrieve list of ${args?.entity} results.`
) {
  const entity = args?.entity ?? ''
  const page = args?.page ?? 1
  const per_page = args?.perPage ?? 10
  const concept_ids = args?.concept_ids ?? {}
  const filters = args?.filters ?? {}
  const filter_keywords = args?.filter_keywords ?? undefined
  const algorithm = args?.algorithm ?? 'standard'
  const select: Record<string, any> = {
    '*': '',
    related_concepts: {
      '*': '',
      __best_document: {
        '*': '',
        source: {id: '', name: '', url: ''},
      },
    },
  }
  if (entity === 'innovation' || entity === 'opportunity') {
    select['business'] = {'*': ''}
  }
  return useQuery({
    queryKey: [JSON.stringify(args)],
    queryFn: async () => {
      try {
        const jsonObj = {
          select: select,
          filter: filters,
          by_concept_weights: concept_ids,
          page: page ?? 1,
          per_page: per_page ?? 10,
          with_count: true,
          algorithm: algorithm,
          docs_must_contain: filter_keywords,
        }
        if (Object.keys(concept_ids).length) {
          const retval = await postData<any>(api2Endpoint(`graph/${entity}`), jsonObj)
          return {
            count: retval?.count ?? 0,
            records: retval.records ?? [],
            next: retval?.next,
            prev: retval?.prev,
          }
        } else {
          return undefined
        }
      } catch (err) {
        errorNotify(err, errMsg)
      }
    },
    cacheTime: queryDefaults.cacheTime,
    staleTime: queryDefaults.staleTime,
    retry: queryDefaults.retry,
  })
}
